export default __webpack_public_path__ + "9b9bb63568280efa602084a272140457.jpg";